<mbs-modal
  #modal
  [isCustomModal]="true"
  [title]="'storages:addStorageAccountWizard.privateStorageModal.title' | i18next">
  <ng-container modal-body>
    <mbs-alert [type]="mbsPopupType.danger">{{ errorText }}</mbs-alert>

    <div class="my-3">{{ 'storages:addStorageAccountWizard.privateStorageModal.text' | i18next }}</div>

    <mbs-checkbox
      [formControl]="confirmation"
      [label]="'storages:addStorageAccountWizard.privateStorageModal.confirmation' | i18next"></mbs-checkbox>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="!confirmation.value"
      (click)="modal.save(true)">
      {{ 'shared:buttons.confirm' | i18next }}
    </mbs-button>

    <mbs-button
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
